import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';

const useUnrealizedPerformanceFeesToDate = () => {
    const { interfaceSDK } = useContext(appContext);

    const { data, error } = useSWR(
        interfaceSDK ? 'unrealizedPerformanceFeesToDate' : null,
        () => interfaceSDK!.get.getUnrealizedPlatformPerformanceFees()
    );

    return {
        unrealizedPerformanceFeesToDate: data,
        isLoading: !error && !data,
        error,
    };
};

export default useUnrealizedPerformanceFeesToDate;
